import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/document-types')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/document-types/${id}`)
    return data
  },

  async create(documentTypeData) {
    const { data } = await api.post('/admin/document-types', documentTypeData)
    return data
  },

  async update(id, documentTypeData) {
    const { data } = await api.put(`/admin/document-types/${id}`, documentTypeData)
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/document-types/${id}`)
    return data
  }
}

